import * as React from "react";
import { useDispatch } from "react-redux";

// style, design
import ModalChapter from "../../Base/Chapters/ModalChapter";
import renderChapter from "./renderChapter";

// store, state
import chapterDefs from "./chapterDefs";
import {
  useTenantGroupForm,
  constants,
  create,
  update,
  destroyPatchForm,
  destroyPostForm,
} from "../../../../store/tenantGroup";
import { cloneDeep } from "lodash";

export default ({ method, id, isOpen, onCheckout, cooperative }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const formLoaded = Boolean(useTenantGroupForm(method, id));

  const checkout = (success) => {
    if (method === "POST") {
      dispatch(destroyPostForm(success));
    } else if (method === "PATCH") {
      dispatch(destroyPatchForm(success));
    }

    onCheckout(success);
  };

  const onSuccess = () => {
    setLoading(false);
    checkout(true);
  };

  const preProcess = (data) => {
    const dataClone = cloneDeep(data);

    if (method === "POST") {
      dataClone.name = `Styrelse ${cooperative.str_representation}`;
      dataClone.category = 0; // board
      dataClone.brf_company = { id: cooperative.id };
    }

    return dataClone;
  };

  const onSubmit = () => {
    setLoading(true);
    if (method === "POST") {
      dispatch(
        create({
          successCallback: onSuccess,
          errorCallback: () => setLoading(false),
          preProcess,
        })
      );
    } else if (method === "PATCH") {
      dispatch(
        update({
          id,
          successCallback: onSuccess,
          errorCallback: () => setLoading(false),
          preProcess,
        })
      );
    }
  };

  const onDone = () => {
    checkout(false);
  };

  return (
    <ModalChapter
      storeName={constants.STORE_NAME}
      chapterDefs={chapterDefs}
      onRenderChapter={(key) => renderChapter({ key, method, cooperative })}
      submitCallback={onSubmit}
      title={method === "POST" ? "Lägg till styrelse" : "Uppdatera styrelse"}
      onDone={onDone}
      loading={!formLoaded || loading}
      isOpen={isOpen}
    />
  );
};
